<template>
    <div class="moboxchain">
        <div class="moboxchain-title show-page">
            <div class="bounceUpIn">
                <div style="display:inline-block;position:relative;" class="t1 bold">
                    MOBOX Chain
                    <div class="coming-title bold">COMING SOON</div>
                </div>
            </div>
            <div class="h2 bold bounceUpIn" style="animation-delay:0.1s">MORE THAN <span class="h2 bold warn"> 150,000 + PLAYERS </span> POWER OUR ECOSYSTEM.</div>

            <div class="h3 bounceUpIn" style="animation-delay:0.2s">A unique NFT POS blockchain network controlled and governed by your in-game assets.  A revolutionary and carbon neutral blockchain where NFTs collected through your in-game experience acts as your node on the MOBOX blockchain network, providing users with near-instant transactions. </div>
        </div>

        <div class="moboxchain-body show-page">
            <div class="line-left">
                <img class="line" src="@/assets/index/moboxchain/lines.png" alt="">
                <div class="line-bg fadeIn" :style="`animation-delay:1.4s;animation-duration:2s`">
                    <div v-for="(item,idx) in 14" :key="idx" :class="`liner-box liner-${idx+1}`">
                        <div class="liner"></div>
                    </div>
                    <img v-for="(item,idx) in 6" :key="idx+14" src="@/assets/index/moboxchain/node.png" :class="`liner-node liner-node-${idx+1}`" />
                </div>
                
                <div class="avatar-1">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(0)}s`" src="@/assets/index/moboxchain/avatar1.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(1)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(1)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">1023</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
                <div class="avatar-2">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(9)}s`" src="@/assets/index/moboxchain/avatar2.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(10)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(10)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">56</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
                <div class="avatar-3">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(5)}s`" src="@/assets/index/moboxchain/avatar3.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(6)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(6)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">254</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
            </div>

            <img class="mbox bounceUpIn" :style="`animation-delay:2s;`" src="@/assets/index/moboxchain/mbox.png" alt="">

            <div class="line-right">
                <img class="line" src="@/assets/index/moboxchain/lines.png" alt="">
                <div class="line-bg fadeIn" :style="`animation-delay:1.6s;animation-duration:2s;transform:scaleX(-1)`">
                    <div v-for="(item,idx) in 14" :key="idx" :class="`liner-box liner-${idx+1}`">
                        <div class="liner"></div>
                    </div>
                    <img v-for="(item,idx) in 6" :key="idx+14" src="@/assets/index/moboxchain/node.png" :class="`liner-node liner-node-${idx+1}`" />
                </div>

                <div class="avatar-4">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(7)}s`" src="@/assets/index/moboxchain/avatar4.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(8)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(8)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">668</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
                <div class="avatar-5">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(3)}s`" src="@/assets/index/moboxchain/avatar5.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(4)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(4)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">2286</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
                <div class="avatar-6">
                    <img class="avatar zoomInBack" :style="`animation-delay:${getDt(11)}s`" src="@/assets/index/moboxchain/avatar6.png" alt="">
                    <div class="hash">
                        <img class="hash-bg rotateInS" :style="`animation-delay:${getDt(12)}s`" src="@/assets/index/moboxchain/hashpower.png" alt="">
                        <div class="hash-box fadeIn" :style="`animation-delay:${getDt(12)}s`">
                            <img class="dig" src="@/assets/index/moboxchain/dig.png" alt="">
                            <div class="bold">1422</div>
                            <div class="bold">Hash</div>
                            <div class="bold">Power</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            avatar:0,
            avatardt:0.12,
        }
    },
    methods:{
        getDt(idx){
            return this.avatar + this.avatardt*idx
        }
    }
}
</script>

<style lang="less" scoped>
    .moboxchain{
        padding: 250px 0 250px 0;

        .moboxchain-title{
            text-align: center;

            .coming-title{
                position: absolute;
                right: 0;
                top: -60px;
                font-family: Poppins-ex;

                color: #BCBCBC;
                background: #000000;
                border-radius: 19px;
                font-size: 30px;
                line-height: 40px;
                padding: 5px 10px;
            }

            .t1{
                line-height: 120px;
            }

            .h2{
                letter-spacing: 0.3px;
            }

            .warn{
                color:rgb(239,181,19);
            }

            .h3{
                width: 850px;
                max-width: 80%;
                margin: auto;

                margin: 60px auto;
            }
        }

        .moboxchain-body{
            width: 70%;
            margin: auto;

            display: flex;
            align-items: center;

            .hash{
                .hash-box{
                    position: absolute;
                    width: 100%;
                    top: 49%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    line-height: 18px;
                    
                    .dig{
                        width: 20%;
                    }
                }
            }

            .line-left{
                margin-right: -3%;
                position: relative;
                
                .line{
                    width: 100%;
                    opacity: 0;
                }

                .avatar-1{
                    position: absolute;
                    width: 40%;
                    left: -7%;
                    top: 50%;
                    transform: translate(0, -50%);

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        top: 50%;
                        transform: translate(0, -50%);
                        left: -40%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }

                .avatar-2{
                    position: absolute;
                    width: 40%;
                    left: 27.5%;
                    top: 5%;

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        top: -26%;
                        right: -12%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }

                .avatar-3{
                    position: absolute;
                    width: 40%;
                    left: 27.5%;
                    bottom: 5%;

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        bottom: -23%;
                        right: -12%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }
            }

            .mbox{
                width: 25%;
            }

            .line-right{
                margin-left: -3%;
                position: relative;

                .line{
                    opacity: 0;
                    width: 100%;
                    transform: rotate(180deg);
                }

                .avatar-4{
                    position: absolute;
                    width: 40%;
                    right: -7%;
                    top: 50%;
                    transform: translate(0, -50%);

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        top: 50%;
                        transform: translate(0, -50%);
                        right: -35%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }

                .avatar-5{
                    position: absolute;
                    width: 40%;
                    right: 27.5%;
                    top: 5%;

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        top: -26%;
                        left: -12%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }

                .avatar-6{
                    position: absolute;
                    width: 40%;
                    right: 27.5%;
                    bottom: 5%;

                    .avatar{
                        width: 100%;
                    }

                    .hash{
                        width: 70%;
                        position: absolute;
                        bottom: -23%;
                        left: -12%;

                        .hash-bg{
                            width: 100%;
                        }
                    }
                }
            }

            .line-bg{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;

                .liner-node{
                    position: absolute;
                    width: 4%;

                    animation: 2s blinker linear infinite;
                }

                .liner-node-1{
                    top: 24%;
                    left: 23%;
                }

                .liner-node-2{
                    top: 70%;
                    left: 22%;
                }

                .liner-node-3{
                    top: 47%;
                    left: 33%;
                }

                .liner-node-4{
                    top: 47%;
                    left: 57%;
                }

                .liner-node-5{
                    top: 23%;
                    left: 68%;
                }

                .liner-node-6{
                    top: 70%;
                    left: 68%;
                }

                .liner-box{
                    width: 30%;
                    height: 1.8%;
                    overflow: hidden;
                    border-radius: 15px;
                }

                .liner{
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent 0%, rgb(237, 183, 33) 100%);
                    border-radius: 15px;

                    animation: 2s goSlide linear infinite;
                }

                .liner-1{
                    position: absolute;
                    top: 25%;
                    left: 2%;
                    width: 20%;
                }
                
                .liner-2{
                    position: absolute;
                    top: 71%;
                    left: 2%;
                    width: 20%;
                }

                .liner-3{
                    position: absolute;
                    top: 11%;
                    left: 22%;
                    width: 20%;
                    transform: rotate(122deg);
                }

                .liner-4{
                    position: absolute;
                    top: 11%;
                    left: 54%;
                    width: 20%;
                    transform: rotate(60deg);
                }

                .liner-5{
                    position: absolute;
                    top: 35%;
                    left: 20%;
                    width: 20%;
                    transform: rotate(60deg);
                }

                .liner-6{
                    position: absolute;
                    top: 37%;
                    left: 56%;
                    width: 18%;
                    transform: rotate(302deg);
                }

                .liner-7{
                    position: absolute;
                    top: 48%;
                    left: 38%;
                    width: 18%;
                    transform: rotate(0deg);
                }
                .liner-8{
                    position: absolute;
                    top: 25%;
                    left: 75%;
                    width: 25%;
                    transform: rotate(0deg);
                }
                .liner-9{
                    position: absolute;
                    top: 48%;
                    left: 65%;
                    width: 25%;
                    transform: rotate(0deg);
                }
                .liner-10{
                    position: absolute;
                    top: 71%;
                    left: 75%;
                    width: 25%;
                    transform: rotate(0deg);
                }

                .liner-11{
                    position: absolute;
                    top: 60%;
                    left: 22%;
                    width: 17%;
                    transform: rotate(-60deg);
                }
                .liner-12{
                    position: absolute;
                    top: 60%;
                    left: 56%;
                    width: 17%;
                    transform: rotate(59deg);
                }
                .liner-13{
                    position: absolute;
                    top: 84%;
                    left: 22%;
                    width: 17%;
                    transform: rotate(-121deg)
                }
                .liner-14{
                    position: absolute;
                    top: 84%;
                    left: 56%;
                    width: 17%;
                    transform: rotate(-60deg);
                }
            }
            
        }
    }
</style>
